import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'equal-not', 'EqualNot', [["path",{"d":"M5 10h14"}],["path",{"d":"M5 14h14"}],["path",{"d":"M5 19l14 -14"}]]);